import { Header } from './Header';

interface PageLayoutProps {
  children: React.ReactNode;
  header?: boolean;
}

export function PageLayout({ children, header = true }: PageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {header && <Header />}
      <main className="flex-1 w-full max-w-2xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
}
